import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {groupsFeatureKey, GroupsState} from "./groups.reducer";

export const getGroupsState = createFeatureSelector<GroupsState>(groupsFeatureKey);

export const getGroups = createSelector(getGroupsState, (state) => state.data);
export const getGroupsLoading = createSelector(getGroupsState, SelectorUtil.isLoading);
